module.exports = __webpack_public_path__ + "img/desc2.0129bd5d.jpg";